<template>
    <div>
        <b-badge class="mr-2" pill v-for="filtro in pills" :key="filtro.id">
            <span class="mx-2">{{filtro.texto}}:</span>
            <span class="mr-2">{{filtro.valor}}</span>
        </b-badge>
    </div>
</template>
<script>
import cloneDeep from "lodash/cloneDeep";
import helpers from "@/common/utils/helpers";
export default {
    data : () => ({
        pills : []
    }),
    props : {
        filtro : {
            required : true,
        }
    },
    watch : {
        filtro : {
            handler(){
                this.pills = [];
                if(!this.filtro)
                    return ;
                    
                this.pills = Object.entries(cloneDeep(this.filtro)).map(el => {
                    let texto = "";
                    switch(el[0]){
                        case "codigoProjeto" :
                            texto = "Código do projeto";
                            break;
                        case "faseInovacao" :
                            texto = "Fase de inovação";
                            break;
                        case "status" :
                            texto = "Status";
                            break;
                        case "DataInicio" :
                            texto = "Data inicial";
                            break;
                        case "DataFim" :
                            texto = "Data final";
                            break;
                        case "ano" :
                            texto = "Ano inicial";
                            break;
                        case "anoFim" :
                            texto = "Ano final";
                            break;
                        case "mesInicio" :
                            texto = "Mês inicial";
                            break;
                        case "mesFim" :
                            texto = "Mês final";
                            break;
                    }

                    let valor = null;
                    if(el[1] != null){
                        switch(el[0]){
                            case "faseInovacao" : case "status" :
                                valor = helpers.getEnum(el[1]).text;
                                break; 
                            case "DataInicio" : case "DataFim" :
                                valor = helpers.formatarDataBr(el[1]);
                                break;
                            default:
                                valor = el[1];
                                break;
                        }
                    }
                    return {
                        id : el[0],
                        texto : texto,
                        valor : valor != "" ? valor : null,
                        original : el[1],
                    }
                }).filter(el => el.valor != null);
            },
            deep : true,
            immediate : true
        }
    }
}
</script>
<style lang="">
    
</style>